import { useInfiniteQuery } from 'react-query';
import { useContext } from 'react';
import { AuthContext } from "../../Context/AuthContext";

const getSupport = async ({ pageParam = 1 }, token) => {
  const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/users/supports?page=${pageParam}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error('Failed to fetch supports');
  }

  return response.json();
};

const useGetSupport = () => {
  const { token } = useContext(AuthContext);

  return useInfiniteQuery(
    ['supports'], 
    ({ pageParam = 1 }) => getSupport({ pageParam }, token),
    {
      getNextPageParam: (lastPage) => {
        const { currentPage, totalSupports } = lastPage;
        const totalPages = Math.ceil(totalSupports / 10); 
        return currentPage < totalPages ? currentPage + 1 : undefined;
      },
    }
  );
};

export default useGetSupport;








